import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { FilterTypesEnum } from 'src/app/models/filters/filterTypes.enum';
import { PlaybookExecutionsFilters } from 'src/app/models/filters/implementations/pageFilters/playbookExecutionsFilters.model';
import { ISelectOption } from 'src/app/models/selectOptions';

@Component({
  selector: 'app-executions-filters',
  templateUrl: './executions-filters.component.html',
  styleUrls: ['./executions-filters.component.scss'],
})
export class ExecutionsFiltersComponent implements OnInit {
  @Input() public pageFilters: PlaybookExecutionsFilters;
  public clearCustomViewSelection$ = new BehaviorSubject(undefined);

  public selectedOptions: ISelectOption[] = [];

  public searchBoxNewValue = new ReplaySubject<string | undefined>(1);
  public lastExecutionSinceNewValue = new ReplaySubject<Date | undefined>(1);
  public lastExecutionUntilNewValue = new ReplaySubject<Date | undefined>(1);
  public selectedCustomOption?: ISelectOption;

  private _customViewTriggered = false;

  constructor(private readonly _router: Router) {}

  ngOnInit(): void {
    this.pageFilters.onUpdate$.subscribe((data) => {
      this.selectedOptions = this.pageFilters.getAllSelectedOptions();

      this.searchBoxNewValue.next(data.search);
      this.lastExecutionSinceNewValue.next(data.lastExecutionSince);
      this.lastExecutionUntilNewValue.next(data.lastExecutionUntil);

      if (this._customViewTriggered) {
        this._customViewTriggered = false;
      } else {
        this.clearCustomViewSelection$.next(undefined);
        this.selectedCustomOption = undefined;
      }
    });
  }

  public tablesFiltersChange(selectedOptions: ISelectOption[]) {
    this.pageFilters.updateFilterFromUserSelection(undefined, selectedOptions);
  }

  public lastExecutionSinceSelected(value?: Date): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.LastExecutionSince, value);
  }

  public lastExecutionUntilSelected(value?: Date): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.LastExecutionUntil, value);
  }

  public searchSubmitted(value?: string): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.Search, value);
  }
}
